import styled from "@emotion/styled";
import { Box, Button, IconButton, Skeleton } from "@mui/material";
import * as CSS from "csstype";
import { TEXT_ELLIPSIS } from "@shared/styles";
import Stack from "@mui/material/Stack";

export const FlexWrapContainer = styled(Box)({
    display: "flex",
    flexDirection: "row",
    padding: "0",
    alignItems: "start",
    flexWrap: "wrap",
    gap: "8px",
});

export const sharedPostActionButtonStyles: CSS.Properties = {
    fontSize: "14px",
    padding: "0 8px",
    backgroundColor: "var(--community-color-transparent-black-05)",
    color: "var(--community-color-primary-text)",
    fontWeight: "400",
    border: "unset",
    lineHeight: "1.75",
    height: "32px",
    borderRadius: "90px !important",
    textTransform: "none",
    minWidth: "unset",
    display: "flex",
    gap: "8px",
};

export const StyledActionButton = styled(IconButton)({
    ...sharedPostActionButtonStyles,
});

export const PollCountBox = styled(Box)({
    ...sharedPostActionButtonStyles,
    alignItems: "center",
    color: "var(--community-color-primary-text)",
});

export const StyledTextActionButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== "isActive" && prop !== "activeColor",
})<{ activeColor?: string; isActive?: boolean }>(
    ({ isActive, activeColor }) => ({
        fontSize: "14px",
        backgroundColor: "transparent",
        color: isActive ? activeColor : "var(--community-color-primary-text)",
        fontWeight: isActive ? "700" : "500",
        border: "unset",
        padding: 0,
        lineHeight: "1.75",
        height: "32px",
        borderRadius: "90px !important",
        textTransform: "none",
        minWidth: "75px",
        "&:hover": {
            backgroundColor: "transparent",
        },
    }),
);

export const SecondaryActionButton = styled(Button)({
    width: "100%",
    margin: 0,
    borderRadius: "4px",
    minHeight: "40px",
    fontSize: "14px",
    color: "var(--community-color-primary-text)",
    display: "flex",
    justifyContent: "flex-start",
    textTransform: "unset",
    lineHeight: "20px",
    paddingLeft: 0,
    backgroundColor: "#509e88",
    "&:hover": {
        backgroundColor: "#509e88",
    },
});

export const LinkoutButtonText = styled("span")({
    fontSize: "14px",
    fontWeight: 400,
    color: "var(--community-color-primary-text)",
    width: "100%",
    textAlign: "start",
    ...TEXT_ELLIPSIS,
});

export const ButtonTextPrimary = styled("span")({
    fontSize: "14px",
    fontWeight: "400",
    ...TEXT_ELLIPSIS,
});

export const StyledToggleButtonSkeleton = styled(Skeleton)({
    height: "26px",
    width: "48px",
    borderRadius: "90px",
});

export const ButtonsContainer = styled("div")({
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    width: "100%",
});

export const QuickActionsContainer = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",
});

export const LikeCommentTextButtonsContainer = styled("div")({
    button: {
        marginRight: 12,
    },
    "button:last-of-type": {
        marginRight: 0,
    },
});

export const ReactionDistributionStack = styled(Stack)({
    height: "4px",
    width: "80%",
    flexDirection: "row",
    position: "absolute",
    bottom: "2px",
    left: "50%",
    transform: "translateX(-50%)",
    overflow: "hidden",
    borderRadius: "16px",
});

export const ReactionDistributionLikeBox = styled(Box)({
    backgroundColor: "#44b700",
});
export const ReactionDistributionDislikeBox = styled(Box)({
    backgroundColor: "#D22F2F",
});
